// extracted by mini-css-extract-plugin
export default {"buttonWrapper":"ResetBtn_buttonWrapper__vfDGK","resetBtn":"ResetBtn_resetBtn__RKSFm","active":"ResetBtn_active__VJxt5","disabledBtn":"ResetBtn_disabledBtn__G9HM0"};